export default __webpack_public_path__ + "73021cf6ae95cf75037189368aac0e31.jpeg";